import o from "clsx";
import e from "react";
import { s as r } from "../../../../../RideGlyph.module-CgKw9y7i.mjs";
function g({
  size: t = "small",
  accessibilityTitle: C = "glyph warning circle solid",
  className: l,
  "data-testid": a,
  fill: i,
  stroke: n
}) {
  const s = () => o(l, r["ride-glyph"], {
    [r[`size-${t}`]]: t
  });
  return /* @__PURE__ */ e.createElement("div", { className: s(), "data-testid": a }, /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: i || "#03050F",
      stroke: n || "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    C && /* @__PURE__ */ e.createElement("title", null, C),
    /* @__PURE__ */ e.createElement("path", { d: "M16 4C12.8174 4 9.76515 5.26427 7.51472 7.51471C5.26428 9.76515 4 12.8174 4 16C4 19.1826 5.26428 22.2349 7.51472 24.4853C9.76515 26.7357 12.8174 28 16 28C19.1826 28 22.2348 26.7357 24.4853 24.4853C26.7357 22.2349 28 19.1826 28 16C28 12.8174 26.7357 9.76515 24.4853 7.51471C22.2348 5.26427 19.1826 4 16 4ZM17.34 9.64001L17.11 17.81H14.89L14.66 9.64001H17.34ZM16 22.36C15.7754 22.3699 15.5512 22.333 15.3417 22.2516C15.1322 22.1702 14.9419 22.046 14.7829 21.8871C14.6239 21.7281 14.4998 21.5378 14.4184 21.3283C14.337 21.1188 14.3001 20.8946 14.31 20.67C14.2974 20.4429 14.3322 20.2157 14.4121 20.0027C14.4921 19.7898 14.6154 19.5958 14.7743 19.4331C14.9333 19.2704 15.1243 19.1426 15.3353 19.0577C15.5463 18.9728 15.7727 18.9327 16 18.94C16.2286 18.9314 16.4564 18.9704 16.6691 19.0546C16.8818 19.1388 17.0747 19.2662 17.2355 19.4289C17.3963 19.5916 17.5215 19.7859 17.6032 19.9996C17.6849 20.2132 17.7213 20.4416 17.71 20.67C17.7186 20.896 17.6801 21.1212 17.5969 21.3315C17.5138 21.5417 17.3878 21.7324 17.227 21.8914C17.0661 22.0503 16.874 22.1741 16.6628 22.2547C16.4515 22.3354 16.2258 22.3712 16 22.36V22.36Z" })
  ));
}
export {
  g as RideGlWarningCircleSolid
};
